import { ReactComponent as HomeIcon } from '../../../assets/icons/solid/home.svg';
import { useGoToDefaultView } from './GoToDefaultView.hooks';
import { Button } from './GoToDefaultView.styles';

export const GoToDefaultView = () => {
  const { flyToDefaultView } = useGoToDefaultView();
  return (
    <Button onClick={flyToDefaultView}>
      <HomeIcon />
    </Button>
  )
}
